import Request from "./Request";

export const LoginRequest = user => {
  return Request(false).post("/api/hello", JSON.stringify(user));
};

export const getUser = id => {
  return Request(true).get(`/api/users/${id}`);
};
